<template>
  <div>
    <v-card outlined :class="{ 'fullscreen': fullscreen }">
      <v-toolbar color="blue-grey  lighten-5" dense>
        <v-toolbar-title class="text-subtitle-1">案卷</v-toolbar-title>
        <v-spacer></v-spacer>
        <div style="width: 150px">
          <v-select dense hide-details="true" item-text="name" item-value="value" :items="yearitems" v-model="year" label="归档年度" style="margin-top:5px;" @change="search()" class="ft1rem"></v-select>
        </div>
        <v-spacer></v-spacer>
        <div style="width: 300px">
          <v-text-field label="搜索 (档号,题名,文件编号,文件题名)" v-model="q" dense flat class="mr-10 ft1rem" hide-details :append-icon="'search'" @keyup.enter.stop="search()" @click:append="search()" style="margin-top:5px;"></v-text-field>
        </div>
        <v-spacer></v-spacer>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn color="primary" icon small v-on="on" @click="switchFullscreen">
              <v-icon>{{ fullscreen ? "fullscreen_exit" : "fullscreen" }}</v-icon>
            </v-btn>
          </template>
          <span>{{ fullscreen ? "退出全屏" : "全屏模式" }}</span>
        </v-tooltip>

        <v-tooltip bottom v-if="canimport">
          <template v-slot:activator="{ on }">
            <v-btn color="primary" small icon v-on="on" @click="openImportZipDialog" :disabled="!active_archive || !archive_permission">
              <v-icon>folder_zip</v-icon>
            </v-btn>
          </template>
          <span>打包导入文件</span>
        </v-tooltip>
        <v-tooltip bottom v-if="canupload">
          <template v-slot:activator="{ on }">
            <v-btn color="primary" small icon v-on="on" @click="openFileDialog" :disabled="!archive_upload || !archive_permission">
              <v-icon>cloud_upload</v-icon>
            </v-btn>
          </template>
          <span>上传文件</span>
        </v-tooltip>
        <v-tooltip bottom v-if="excel_permission && !inrole([5])">
          <template v-slot:activator="{ on }">
            <v-btn color="primary" small icon v-on="on" @click="downloadExcel" :disabled="!active_archive">
              <v-icon>print</v-icon>
            </v-btn>
          </template>
          <span>导出Excel</span>
        </v-tooltip>
        <v-tooltip bottom v-if="excel_permission && !inrole([5])">
          <template v-slot:activator="{ on }">
            <v-btn color="primary" small icon v-on="on" @click="downloadPrintExcel" :disabled="!active_archive">
              <v-icon>category</v-icon>
            </v-btn>
          </template>
          <span>导出卷内目录</span>
        </v-tooltip>
        <v-tooltip bottom v-if="canedit">
          <template v-slot:activator="{ on }">
            <v-btn color="green" small icon v-on="on" @click="openEditDialog" :disabled="!active_archive || !archive_permission">
              <v-icon>edit</v-icon>
            </v-btn>
          </template>
          <span>编辑案卷</span>
        </v-tooltip>
        <v-tooltip bottom v-if="candelete">
          <template v-slot:activator="{ on }">
            <v-btn color="error" small icon v-on="on" @click="deleteArchive" :disabled="!active_archive || !archive_permission">
              <v-icon>delete</v-icon>
            </v-btn>
          </template>
          <span>删除案卷</span>
        </v-tooltip>
      </v-toolbar>
      <c-category-archive-list ref="list" :vh="vh" :verify="verify" :fullscreen="fullscreen"></c-category-archive-list>
    </v-card>
    <archive-edit-dialog ref="_archive_dialog"></archive-edit-dialog>
    <file-upload-dialog ref="_file_dialog"></file-upload-dialog>
    <input type="file" ref="_zip_file_input" style="display: none" accept=".zip" @change="onZipFileChange" />
  </div>
</template>

<script>
import { mapState, mapWritableState } from "pinia";
import { useUserStore } from "@/stores/userStore.js";
import { useFolderStore } from "@/stores/folderStore.js";
import { useArchiveStore } from "@/stores/archiveStore.js";
import { useRecordStore } from "@/stores/recordStore.js";
import { useDocumentStore } from "@/stores/documentStore.js";
import fileDownload from "js-file-download";
import Axios from "axios";
export default {
  name: "CArchivesByCategory",
  props: [
    "vh",
    "canedit",
    "candelete",
    "canupload",
    "canimport",
    "verify",
  ],
  data() {
    return {
      fullscreen: false,
      yearitems: [],
    };
  },
  computed: {
    apiroot() {
      return process.env.VUE_APP_API;
    },
    ...mapState(useUserStore, ["profile", "userToken"]),
    ...mapState(useArchiveStore, [
      "active_archive",
      "archive_permission",
      "excel_permission"
    ]),
    ...mapState(useRecordStore, {
      records: "data",
    }),
    ...mapState(useDocumentStore, {
      documents: "data",
    }),
    ...mapWritableState(useArchiveStore, ["q", "year"]),
    archive_upload() {
      if (!this.active_archive) return false;
      if (this.records && this.records.length) return false;
      return true;
    },
  },
  mounted() {
    this.yearitems.push({
      name: "所有",
      value: 0,
    });
    const currentYear = new Date().getUTCFullYear();
    for (var y = currentYear; y >= 1949; y--) {
      this.yearitems.push({
        name: y + "",
        value: y,
      });
    }
  },
  methods: {
    inrole(arr) {
      const userStore = useUserStore();
      return userStore.isUserInRoles(arr);
    },
    openEditDialog() {
      //实体分类模式下没有"当前目录"，按案卷所属的 folderid 反查目录的拼号规则和全宗号
      const folderStore = useFolderStore();
      const folder = this.$g.treeFindOne(this.active_archive.folderid, folderStore.data);
      const root = this.$g.treeRoot(this.active_archive.folderid, folderStore.data);
      var config = {
        type: 1,
        archive: {
          ...this.active_archive,
          rootno: root ? root.name : "",
          customfield: "",
        },
        rules: (folder && folder.activerules) || [],
      };
      this.$refs._archive_dialog.openDialog(config);
    },
    deleteArchive() {
      this.$confirm(
        "确定要删除这个案卷吗? 该案卷及其包含的文件都将被删除"
      ).then((x) => {
        if (x) {
          const store = useArchiveStore();
          store.delete();
        }
      });
    },
    search() {
      const store = useArchiveStore();
      store.pageindex = 1;
      store.loadData(true);
    },
    openFileDialog() {
      this.$refs._file_dialog.openDialog(this.active_archive.id, 0);
    },
    openImportZipDialog() {
      this.$refs._zip_file_input.click();
    },
    onZipFileChange() {
      var file = event.target.files;
      if (file && file.length > 0) {
        const store = useArchiveStore();
        const docstore = useDocumentStore();
        store.importZip(file[0], this.active_archive.id).subscribe(
          (x) => {
            docstore.loadData();
          },
          (x) => { }
        );
        event.target.value = "";
      }
    },
    switchFullscreen() {
      const store = useArchiveStore();
      this.fullscreen = !this.fullscreen;
      if (this.fullscreen) {
        store.pagesize = 0;
        store.loadData();
      } else {
        store.pagesize = 10;
        store.loadData();
      }
    },
    downloadExcel() {
      var file = this.active_archive.name || this.active_archive.title;
      file = file || this.active_archive.id;
      this.$ns.cast("lock", true);
      const tk = this.userToken;
      Axios({
        method: "get",
        url: `${this.apiroot}archives/excel/${this.active_archive.id}`,
        headers: {
          "Content-Type": "text/json",
          Authorization: `Bearer ${tk.Token}`,
        },
        responseType: "blob",
      })
        .then((x) => {
          fileDownload(x.data, file + ".xlsx");
        })
        .finally(() => this.$ns.cast("lock", false));
    },
    downloadPrintExcel() {
      var file = this.active_archive.name || this.active_archive.title;
      file = file || this.active_archive.id;
      this.$ns.cast("lock", true);
      const tk = this.userToken;
      Axios({
        method: "get",
        url: `${this.apiroot}archives/excelcatelog/${this.active_archive.id}`,
        headers: {
          "Content-Type": "text/json",
          Authorization: `Bearer ${tk.Token}`,
        },
        responseType: "blob",
      })
        .then((x) => {
          fileDownload(x.data, file + "_卷内目录.xlsx");
        })
        .finally(() => this.$ns.cast("lock", false));
    }
  },
};
</script>
